import { render, staticRenderFns } from "./section-suggestion.vue?vue&type=template&id=7df54ba6&scoped=true"
import script from "./section-suggestion.vue?vue&type=script&lang=js"
export * from "./section-suggestion.vue?vue&type=script&lang=js"
import style0 from "./section-suggestion.vue?vue&type=style&index=0&id=7df54ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df54ba6",
  null
  
)

export default component.exports